import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.QBooksMatchingInfo.QBooksMatchingInfoContentOld', {
    deleteButtonTitle: 'Remove the matching',
    deleteConfirmationText: 'Sure?',
    remove: 'Remove',
    date: 'Date: <b>{date}</b>',
    amount: 'Amount: <b>{amount}</b>',
});
